import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const serializeLedgerMap: SerializeMap<BillingLedgerEntryEditableFields> = {
  category: "category",
  description: "description",
  documentId: "document_id",
  glCode: "gl_code",
  id: "id",
  includeIfZero: "include_if_zero",
  invoiceCategory: "invoice_category",
  isModified: "is_modified",
  itemId: "item_id",
  itemType: "item_type",
  notes: "notes",
  quantityOutputFormat: "quantity_output_format",
  quantityRawFormat: "quantity_raw_format",
  unitAmountOutputFormat: "unit_amount_output_format",
  unitAmountRawFormat: "unit_amount_raw_format",
  quantity: "quantity",
  subtotal: "subtotal",
  tagIds: "tag_ids",
  taxAmount: "tax_amount",
  taxType: "tax_type",
  unitAmount: "unit_amount",
};

const deserializeMap: SerializeMap<BillingLedgerEntry> = {
  ...serializeLedgerMap,
  billingReference: "billing_reference",
  mincenousId: "mincenous_id",
  prerequisiteLedgerEntryId: "prerequisite_ledger_entry_id",
  ruleId: "rule_id",
  ruleName: "rule_name",
  status: "status",
};

export const serializeLedgerEntry = buildSerializer(
  serializeLedgerMap,
  "ledgerEntry",
);

export const deserializeLedgerEntry = buildDeserializer(
  deserializeMap,
  "ledgerEntry",
);
